import { Action } from 'redux';

import {
    AIRPORTS_FARES_ERROR,
    AIRPORTS_FARES_REQUEST,
    AIRPORTS_FARES_RESPONSE,
    CLEAR_SEARCH_OBJECT,
    CLEAR_SEARCH_RESULTS,
    CREATE_SEARCH_FARES_ERROR,
    CREATE_SEARCH_FARES_REQUEST,
    CREATE_SEARCH_FARES_RESPONSE,
    GET_AVIASALES_PAYMENT_LINK_ERROR,
    GET_AVIASALES_PAYMENT_LINK_REQUEST,
    GET_AVIASALES_PAYMENT_LINK_RESPONSE
} from '../../actions/Flight/fares';

import { SearchObject } from '../../models/Flight/SearchObject';
import { Airline, Airport, Gate, Plane, Ticket } from '../../models/Flight/Flight';
import { OrderedMap } from 'immutable';
import { FLIGHT_CLEAR_FILTERS, FLIGHT_INIT_FILTERS, FLIGHT_SET_FILTERS } from '../../actions/Flight/filters';
import { Filter } from '../../models/Flight/Filters';

export interface FaresState {
    loading: boolean;
    error: string | null;

    searchObject: SearchObject | null;
    loadingSearchObject: boolean;
    errorSearchObject: string | null;
    completedSearch: boolean;
    airlines: OrderedMap<string, Airline>;
    airports: OrderedMap<string, Airport>;
    gates: OrderedMap<string, Gate>;
    planes: OrderedMap<string, Plane>;
    tickets: Array<Ticket>;

    filteredTickets: Array<Ticket>;
    filters: OrderedMap<string, Filter>;
    filtersValues: OrderedMap<string, any>;

    loadingPaymentLink: boolean;
    paymentLink: string;
    errorPaymentLink: any;

    countFilters: number;
}

const initialState: FaresState = {
    loading: false,
    error: null,

    searchObject: localStorage.flights_search_object ? JSON.parse(localStorage.flights_search_object) : null,
    loadingSearchObject: false,
    errorSearchObject: null,
    completedSearch: false,
    airlines: OrderedMap<string, Airline>(),
    airports: OrderedMap<string, Airport>(),
    gates: OrderedMap<string, Gate>(),
    planes: OrderedMap<string, Plane>(),
    tickets: Array<Ticket>(),

    filteredTickets: Array<Ticket>(),
    filters: OrderedMap<string, Filter>(),
    filtersValues: parseFiltersValues(localStorage.filters_values),

    loadingPaymentLink: false,
    paymentLink: '',
    errorPaymentLink: null,
    countFilters: -1
};

function parseFiltersValues(filtersValues: any) {
    if (!!filtersValues) {
        const parsedValues = JSON.parse(filtersValues);
        let filters: OrderedMap<string, any> = OrderedMap<string, any>();
        Object.keys(parsedValues).map(key => {
            filters = filters.set(key, parsedValues[key]);
        });
        return filters;
    } else {
        return OrderedMap<string, any>();
    }
}

function filterTickets(ticketsState: Array<Ticket>, filtersValuesState: OrderedMap<string, any>) {
    let tickets = ticketsState;
    filtersValuesState.keySeq().toArray().map(keyFilter => {
        switch (keyFilter) {
            case 'airlines': {
                const filterValues = filtersValuesState.get(keyFilter);
                filterValues.map(filterValue => {
                    tickets = tickets.filter(ticket => ticket.carriers ? ticket.carriers.indexOf(filterValue) !== -1 : false);
                });
                return ;
            }
            case 'gates': {
                const filterValues = filtersValuesState.get(keyFilter);
                filterValues.map(filterValue => {
                    tickets = tickets.filter(ticket => ticket.proposals ? !!ticket.proposals.find(proposal => proposal.gate_id === filterValue) : false);
                });
                return ;
            }
            case 'aircrafts': {
                const filterValues = filtersValuesState.get(keyFilter);
                filterValues.map(filterValue => {
                    tickets = tickets.filter(ticket => {
                        let has = false;
                        ticket.segment.map(segment => {
                            segment.flight.map(flight => {
                                if (flight.aircraft === filterValue) {
                                    has = true;
                                    return;
                                }
                            });
                        });
                        return has;
                    });
                });
                return ;
            }
            case 'hasNightTransfer': {
                tickets = tickets.filter(ticket => {
                    return ticket.tags ? ticket.tags.indexOf('has_night_transfer') === -1 : false;
                });
                return ;
            }
            case 'hasFreeBaggage': {
                tickets = tickets.filter(ticket => {
                    let has = false;
                    ticket.proposals.map(proposal => {
                        if (proposal.flights_baggage) {
                            proposal.flights_baggage.map(baggage => {
                                if (baggage && baggage.length > 0 && baggage !== '0PC') {
                                    has = true;
                                    return;
                                }
                            });
                        }
                    });
                    return has;
                });
                return ;
            }
            case 'prices': {
                const filterValues = filtersValuesState.get(keyFilter);
                const minValue = filterValues[0];
                const maxValue = filterValues[1];
                tickets = tickets.filter(ticket => {
                    let has = false;
                    ticket.proposals.map(proposal => {
                        if (proposal.price > Number(minValue) && proposal.price < Number(maxValue)) {
                            has = true;
                            return;
                        }
                    });
                    return has;
                });
                return ;
            }
            case 'durations': {
                const filterValues = filtersValuesState.get(keyFilter);
                const minValue = filterValues[0];
                const maxValue = filterValues[1];
                tickets = tickets.filter(ticket => {
                    let has = false;
                    if (ticket.total_duration > Number(minValue) && ticket.total_duration < Number(maxValue)) {
                        has = true;
                    }
                    return has;
                });
                return ;
            }
            case 'onlyDirectFlights': {
                tickets = tickets.filter(ticket => {
                    return ticket.is_direct;
                });
                return ;
            }
            case 'transfersFilter': {
                const filterValues = filtersValuesState.get(keyFilter);
                tickets = tickets.filter(ticket => {
                    let has = false;
                    ticket.segment.map(segment => {
                        if (filterValues.indexOf((segment.flight.length - 1).toString()) >= 0) {
                            has = true;
                        }
                    });
                    return has;
                });
                return ;
            }
            case 'departureTime': {
                const filterValues = filtersValuesState.get(keyFilter);
                const minValue = filterValues[0];
                const maxValue = filterValues[1];
                tickets = tickets.filter(ticket => {
                    let time = ticket.segment[0].flight[0].local_departure_timestamp % 86400 / 60;
                    return time >= minValue && time <= maxValue;
                });
                return ;
            }
            default: return ;
        }
    });
    return tickets;
}

export function fares(state: FaresState = initialState, action: Action) {
    switch (action.type) {
        case CREATE_SEARCH_FARES_REQUEST: {
            return {
                ...state,
                searchObject: initialState.searchObject,
                loadingSearchObject: true,
                errorSearchObject: initialState.errorSearchObject,
                completedSearch: false
            };
        }
        case CREATE_SEARCH_FARES_RESPONSE: {
            const searchObject: SearchObject = (action as any).response.result;
            localStorage.setItem('flights_search_object', JSON.stringify(searchObject));
            return {
                ...state,
                searchObject,
                loadingSearchObject: false
            };
        }
        case CREATE_SEARCH_FARES_ERROR: {
            const errorSearchObject = (action as any).error;
            return {
                ...state,
                loadingSearchObject: false,
                errorSearchObject
            };
        }
        case CLEAR_SEARCH_OBJECT: {
            localStorage.removeItem('flights_search_object');
            return {
                ...state,
                searchObject: null,
                error: initialState.error,
                errorSearchObject: initialState.errorSearchObject
            };
        }
        case AIRPORTS_FARES_REQUEST: {
            let countFilters = state.countFilters;
            if (countFilters === -1) {
                countFilters = state.filtersValues.valueSeq().reduce((sum: number, value) => value.length ? sum + value.length : sum + 1, 0);
            }
            return {
                ...state,
                loading: true,
                error: initialState.error,
                completedSearch: false,
                countFilters
            };
        }
        case AIRPORTS_FARES_RESPONSE: {
            const result = (action as any).response.result;
            if (result) {
                if (!result.completed) {
                    return {
                        ...state,
                        loading: false
                    };
                } else {
                    const airlines = result.airlines;
                    const airports = result.airports;
                    const gates = result.gates;
                    const planes = result.planes;
                    const tickets = result.tickets;
                    const filteredTickets = filterTickets(tickets, state.filtersValues);
                    return {
                        ...state,
                        loading: false,
                        completedSearch: true,
                        airlines,
                        airports,
                        gates,
                        planes,
                        tickets,
                        filteredTickets,
                        filters: initialState.filters
                    };
                }
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        }
        case AIRPORTS_FARES_ERROR: {
            const error = (action as any).error;
            return {
                ...state,
                loading: false,
                completedSearch: true,
                error
            };
        }
        case CLEAR_SEARCH_RESULTS: {
            return {
                ...state,
                airlines: initialState.airlines,
                airports: initialState.airports,
                gates: initialState.gates,
                planes: initialState.planes,
                tickets: initialState.tickets,
                filteredTickets: initialState.filteredTickets
            };
        }
        case GET_AVIASALES_PAYMENT_LINK_REQUEST: {
            return {
                ...state,
                loadingPaymentLink: true,
                paymentLink: initialState.paymentLink
            };
        }
        case GET_AVIASALES_PAYMENT_LINK_RESPONSE: {
            const result = (action as any).response.result;
            if (result && result.url) {
                window.location.href = result.url;
                return {
                    ...state,
                    loadingPaymentLink: false,
                    paymentLink: result.url
                };
            } else {
                return {
                    ...state,
                    loadingPaymentLink: false,
                    errorPaymentLink: 'Ошибка при получении url для оплаты'
                };
            }
        }
        case GET_AVIASALES_PAYMENT_LINK_ERROR: {
            const errorPaymentLink = (action as any).response.error;
            console.log(errorPaymentLink);
            return {
                ...state,
                loadingPaymentLink: false,
                errorPaymentLink
            };
        }
        case FLIGHT_SET_FILTERS: {
            const filterName = (action as any).filterName;
            const filterValue = (action as any).filterValue;
            let filtersValues;
            const currentFilter = state.filters.get(filterName);
            const currentFilterValues = state.filtersValues.get(filterName);
            if (!!currentFilter) {
                if (currentFilter.type !== 'flag' && currentFilter.type !== 'range') {
                    if (currentFilterValues && currentFilterValues.length > 0) {
                        let findOptionIndex = currentFilterValues.indexOf(filterValue);
                        if (findOptionIndex === -1) {
                            currentFilterValues.push(filterValue);
                            filtersValues = state.filtersValues.set(filterName, currentFilterValues);
                        } else {
                            if (currentFilterValues.length === 1) {
                                filtersValues = state.filtersValues.remove(filterName);
                            } else {
                                currentFilterValues.splice(findOptionIndex, 1);
                                filtersValues = state.filtersValues.set(filterName, currentFilterValues);
                            }
                        }
                    } else {
                        const newArray: Array<string> = Array<string>();
                        newArray.push(filterValue);
                        filtersValues = state.filtersValues.set(filterName, newArray);
                    }
                } else {
                    if (!filterValue) {
                        filtersValues = state.filtersValues.remove(filterName);
                    } else {
                        filtersValues = state.filtersValues.set(filterName, filterValue);
                    }
                }
            } else {
                filtersValues = state.filtersValues.set(filterName, filterValue);
            }
            const filteredTickets = filterTickets(state.tickets, filtersValues);
            const countFilters = filtersValues.valueSeq().reduce((sum: number, value) => value.length ? sum + value.length : sum + 1, 0);
            return {
                ...state,
                filtersValues,
                filteredTickets,
                countFilters
            };
        }
        case FLIGHT_CLEAR_FILTERS: {
            return {
                ...state,
                filtersValues: OrderedMap<string, any>(),
                filteredTickets: state.tickets,
                countFilters: initialState.countFilters
            };
        }
        case FLIGHT_INIT_FILTERS: {
            const filters = (action as any).filters;
            return {
                ...state,
                filters
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Flight/fares.ts